<!--
 * @Copyright: 中国信息安全测评中心
 * @Author: xiaowenwen
 * @Date: 2021-06-28 11:31:44
 * @LastEditTime: 2022-04-06 17:03:37
 * @Description: 
-->
<template>
  <div class="control-box">
    <el-divider content-position="left"
      >设置关闭左侧的菜单/系统设置显示的模块</el-divider
    >
    <el-form label-width="120px">
      <div>
        <el-form-item label="左侧导航：">
          <el-checkbox-group v-model="checkedmenus">
            <el-checkbox v-for="menu in menus" :label="menu" :key="menu">{{
              menu
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="系统设置：">
          <el-checkbox-group v-model="checkedsettings">
            <el-checkbox
              v-for="setting in settings"
              :label="setting"
              :key="setting"
              >{{ setting }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="">
          *注: 勾选设置左侧菜单/系统设置显示的模块的显示/隐藏, 勾选后模块显示;
        </el-form-item>
        <el-form-item label=""><p></p> </el-form-item>
        <el-form-item label=""><p></p> </el-form-item>
        <el-form-item label=""><p></p> </el-form-item>
        <el-form-item label=""><p></p> </el-form-item>
        <el-form-item label=""><p></p> </el-form-item>
        <el-form-item label=""><p></p> </el-form-item>
      </div>

      <el-form-item>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import ADMIN from "@/api/admin";

export default {
  data() {
    return {
      form: null,
      current: "0",
      menuConfig: {},
      savemenuConfig: {},
      checkedmenus: [],
      checkedsettings: [],

      menus: [
        "扩展设置",
        "扩展组件列表",
        "扩展邮件列表",
        "日志管理",
        "数据分析"
      ],
      settings: [
        "登陆设置",
        "邮件列表设置",
        "账号删除设置",
        "密码强度设置",
        "数据存储设置",
        "通知邮箱设置",
        "短信接口设置"
      ]
    };
  },
  computed: {},
  async created() {
    let response = await ADMIN.MENU();
    if (response.data.state) {
      this.menuConfig = response.data.config;
      for (var i = 0; i < this.menus.length; i++) {
        //console.log(this.menus[i]);
        //console.log(this.menuConfig[this.menus[i]]);
        if (this.menuConfig[this.menus[i]] !== false) {
          this.checkedmenus.push(this.menus[i]);
        }
      }
      for (var j = 0; j < this.settings.length; j++) {
        //console.log(this.settings[j]);
        //console.log(this.menuConfig[this.settings[j]]);
        if (this.menuConfig[this.settings[j]] !== false) {
          this.checkedsettings.push(this.settings[j]);
        }
      }
    }
  },

  methods: {
    async handleSave() {
      try {
        var json = {};
        for (var i = 0; i < this.menus.length; i++) {
          var field = this.menus[i];
          if (this.checkedmenus.indexOf(field) >= 0) {
            json[field] = true;
            // json.this.menus[i] = true;
          } else {
            json[field] = false;
            // json.this.menus[i] = false;
          }
        }
        console.log(json);
        for (var j = 0; j < this.settings.length; j++) {
          var fieldj = this.settings[j];
          if (this.checkedsettings.indexOf(fieldj) >= 0) {
            json[fieldj] = true;
            // json.this.menus[i] = true;
          } else {
            json[fieldj] = false;
            // json.this.menus[i] = false;
          }
        }
        let response = await ADMIN.MENU_SETTING(json);
        if (response.data.state) {
          this.$message.success(
            "系统信息保存成功, 页面刷新后查看设置后的显示隐藏."
          );
        } else {
          this.$message.error(response.data.message ?? "系统信息成功失败");
        }
        // eslint-disable-next-line no-empty
      } catch {}
    }
  }
};
</script>

<style lang="less" scoped>
.control-box {
  height: 100%;
  padding: 0 10px;
  overflow: auto;
  width: 600px;
}
.el-divider {
  margin: 30px 0;
  .el-divider__text {
    color: #1f8fff;
    font-weight: bold;
  }
}
.el-form {
  ::v-deep * {
    font-size: 13px;
  }
  label.label-red {
    color: #ff9e00;
    margin-left: 6px;
  }
}
</style>
